export const INTAKE_ROUTES = {
  DASHBOARD: "/dashboard",
  SEARCH: "/platform/search",
  INTAKE: "/dashboard",
  INTAKE_DASHBOARD: "/dashboard",
  INTAKE_DRAFTS: "/drafts",
  INTAKE_RECORDS: "/records",
  INTAKE_DIGEST: "/digest",
  INTAKE_LEDGER: "/ledger",
  MAILBOX: "/mailbox",
  CONVERSATIONS: "/conversations",
  CONVERSATIONS_CHANNEL_SCOPE: "/conversations/channel-scope",
} as const;

export type IntakeRouteKey = keyof typeof INTAKE_ROUTES;
